

(function( ){


//------------------------------------------------------------------------------------------------------------------------------

// -   -   -   -   -   -   -   -   -   -   -   -   -   -   -   -   -   -   -   -   -   -   -   -   -   -   -   -   -   -   -   -

	Utils = window.Utils || {} ;

	Utils.Image = { } ;

//------------------------------------------------------------------------------------------------------------------------------

	/*
	var $config =
	{
		selector:"js-responsive-img" ,
		preload:true,
		breakpoint:
		[	// 小さい順に配列に格納
			{ minWidth:0 , src:"data-src-sp" , className:"sp" } ,
			{ minWidth:751 , src:"data-src-pc" , className:"pc" }
		]
	}
	*/

	Utils.Image.responsive = function( $config )
	{
		Utils.Image.responsive.config = $config ;
		Utils.Image.responsive.breakpoint = $config.breakpoint ;
		Utils.Image.responsive.selectorRegExp = new RegExp( Utils.Image.responsive.config.selector , "gi" ) ;
		if( $config.preload != undefined )		Utils.Image.responsive.preload = $config.preload ;

		var $i ;

		var $onResize = function( )
		{
			Utils.Image.responsive.breakpointIndex = 0 ;

			for( $i = 0 ; $i < Utils.Image.responsive.breakpoint.length ; $i++ )
			{
				if( Utils.Image.responsive.breakpoint[$i].minWidth < Utils.Stage.width )
				{
					Utils.Image.responsive.breakpointIndex = $i ;
				}
				else
				{
					break ;
				}
			}

			Utils.Image.responsive.focusBreakpoint = Utils.Image.responsive.config.breakpoint[ Utils.Image.responsive.breakpointIndex ] ;
		}
		$onResize( ) ;
		Resize.add( $onResize ) ;

		var $targetImg = Utils.DOM.get( "img."+Utils.Image.responsive.config.selector , Utils.DOM.body ) ;

		for( $i = 0 ; $i < $targetImg.length ; $i++ )
		{
			new Utils.Image.responsive.obj( $targetImg[$i] ) ;
		}
	}
	Utils.Image.responsive.breakpointIndex = 0 ;
	Utils.Image.responsive.focusBreakpoint = null ;
	Utils.Image.responsive.selectorRegExp = null ;
	Utils.Image.responsive.config = null ;
	Utils.Image.responsive.breakpoint = null ;
	Utils.Image.responsive.preload = false ;
	Utils.Image.responsive.obj = function( $targetImg )
	{
		$targetImg.style.display = "none" ;

		var $targetClassName = $targetImg.className.replace( Utils.Image.responsive.selectorRegExp , "" ) ;

		var $responsiveImg = [] ;
		var $img ;
		for( $i = 0 ; $i < Utils.Image.responsive.breakpoint.length ; $i++ )
		{
			$img = $responsiveImg[$responsiveImg.length] = document.createElement( "img" ) ;
			$img.className = $targetClassName + Utils.Image.responsive.breakpoint[$i].className ;
			if( Utils.Image.responsive.preload )	$img.src = $targetImg.getAttribute( Utils.Image.responsive.breakpoint[$i].src ) ;
			$targetImg.parentNode.insertBefore( $img , $targetImg ) ;
		}

		var $visibleImg = $responsiveImg[0] ;

		var $onResize = function( )
		{
			$visibleImg = $responsiveImg[ Utils.Image.responsive.breakpointIndex ] ;

			if( !$visibleImg.src )	$visibleImg.src = $targetImg.getAttribute( Utils.Image.responsive.focusBreakpoint.src ) ;
		}
		$onResize( ) ;
		Resize.add( $onResize ) ;
	}

//------------------------------------------------------------------------------------------------------------------------------

	Utils.Image.getSize = function( $img )
	{
		var $obj = { w:null , h:null } ;

		if( $img.naturalWidth !== undefined )
		{
			$obj.w = $img.naturalWidth ;
			$obj.h = $img.naturalHeight ;
		}
		else if( $img.runtimeStyle !== undefined ) // IE
		{
			var $style = $img.runtimeStyle ;

			$style.width = "auto";
			$style.height = "auto";

			$obj.w = $img.width ;
			$obj.h = $img.height ;
		}
		else // Opera
		{
			$img.removeAttribute("width");
			$img.removeAttribute("height");

			$obj.w = $img.width ;
			$obj.h = $img.height ;
		}

		return $obj ;
	}

//------------------------------------------------------------------------------------------------------------------------------

	Utils.Image.data = { } ;

	//       -       -       -       -       -       -       -       -

	Utils.Image.set = function( $img , $id )
	{
		$id = $id == null ? $url : $id ;

		Utils.Image.data[$id] = $img ;
	}

	//       -       -       -       -       -       -       -       -

	Utils.Image.get = function( $id )
	{
		return Utils.Image.data[$id] ;
	}

	//       -       -       -       -       -       -       -       -

	Utils.Image.cacheDate = "?" + ( new Date( ) ).getTime( ) ;
	Utils.Image.loadCount = 0 ;
	Utils.Image.load = function( $url , $id , $callback , $isNoneCache , $notAddedList )
	{
		if( Utils.Image.data[$id] && Utils.Image.data[$id].complete )
		{
			if( $callback )		$callback( ) ;
			return ;
		}

		//

		Utils.Image.loadCount ++ ;

		$id = $id == null ? $url : $id ;

		var $img = document.createElement( "img" ) ;

		$img.onload = function( )
		{
			if( !$notAddedList )	Utils.Image.data[$id] = $img ;
			var $size = Utils.Image.getSize( $img ) ; // { w:Number , y:Number } ;
			$img.width = $size.w ;
			$img.height = $size.h ;

			if( $callback )		$callback( ) ;

			$img.onload = null ;
		}

		$img.src = $isNoneCache ? $url + Utils.Image.cacheDate + Utils.Image.loadCount : $url ;

		if( $img.complete )
		{
			$img.onload( ) ;
			$img.onload = null ;
		}

		return $img ;
	}

	//       -       -       -       -       -       -       -       -

	Utils.Image.load.array = function( $arr , $callback , $isNoneCache , $isReplace )
	{
		var $i ;
		var $count = $arr.length ;

		var $onLoaded = function( )
		{
			$count -- ;
			if( $count )		return ;

			if( $callback )		$callback( ) ;
		}

		if( $isReplace )
		{
			for( $i in $arr )
			{
				if( $arr[$i] instanceof Array )			$arr[$i] = Utils.Image.load.array( $arr[$i] , $onLoaded , $isNoneCache , $isReplace ) ;
				else if( $arr[$i] instanceof Object )	$arr[$i] = Utils.Image.load.object( $arr[$i] , $onLoaded , $isNoneCache , $isReplace ) ;
				else									$arr[$i] = Utils.Image.load( $arr[$i] , $i , $onLoaded , $isNoneCache , $isReplace ) ;
			}
		}
		else
		{
			for( $i in $arr )
			{
				if( $arr[$i] instanceof Array )			Utils.Image.load.array( $arr[$i] , $onLoaded , $isNoneCache ) ;
				else if( $arr[$i] instanceof Object )	Utils.Image.load.object( $arr[$i] , $onLoaded , $isNoneCache ) ;
				else									Utils.Image.load( $arr[$i] , $i , $onLoaded , $isNoneCache ) ;
			}
		}

		return $arr ;
	}

	Utils.Image.load.object = function( $obj , $callback , $isNoneCache , $isReplace )
	{
		var $i ;
		var $count = 0 ;

		var $onLoaded = function( )
		{
			$count -- ;
			if( $count )		return ;

			if( $callback )		$callback( ) ;
		}

		if( $isReplace )
		{
			for( $i in $obj )	$count ++ ;
			for( $i in $obj )
			{
				if( $obj[$i] instanceof Array )			$obj[$i] = Utils.Image.load.array( $obj[$i] , $onLoaded , $isNoneCache , $isReplace ) ;
				else if( $obj[$i] instanceof Object )	$obj[$i] = Utils.Image.load.object( $obj[$i] , $onLoaded , $isNoneCache , $isReplace ) ;
				else									$obj[$i] = Utils.Image.load( $obj[$i] , $i , $onLoaded , $isNoneCache , $isReplace ) ;
			}
		}
		else
		{
			for( $i in $obj )	$count ++ ;
			for( $i in $obj )
			{
				if( $obj[$i] instanceof Array )			Utils.Image.load.array( $obj[$i] , $onLoaded , $isNoneCache ) ;
				else if( $obj[$i] instanceof Object )	Utils.Image.load.object( $obj[$i] , $onLoaded , $isNoneCache ) ;
				else									Utils.Image.load( $obj[$i] , $i , $onLoaded , $isNoneCache ) ;
			}
		}

		return $obj ;
	}

	//       -       -       -       -       -       -       -       -

	Utils.Image.colorTransform = function( $sourceImg , $colorTransRGBA )
	{
		var $newCanvas = document.createElement( "canvas" ) ;
		$newCanvas.width = $sourceImg.width ;
		$newCanvas.height = $sourceImg.height ;
		var $newContext = $newCanvas.getContext( "2d" ) ;
		$newContext.drawImage( $sourceImg , 0 , 0 ) ;

		var $imgData = $newContext.getImageData( 0 , 0 , $sourceImg.width , $sourceImg.height ) ;
		var $data = $imgData.data ;
		var $length = $data.length ;
		for( var $i = 0 ; $i < $length ; $i += 4 )
		{
			$data[ $i+0 ] = $data[ $i+0 ] * $colorTransRGBA[0] ;
			$data[ $i+1 ] = $data[ $i+1 ] * $colorTransRGBA[1] ;
			$data[ $i+2 ] = $data[ $i+2 ] * $colorTransRGBA[2] ;
			$data[ $i+3 ] = $data[ $i+3 ] * $colorTransRGBA[3] ;
		}

		$newContext.putImageData( $imgData , 0 , 0 ) ;

		return $newCanvas ;
	}

	//       -       -       -       -       -       -       -       -

	Utils.Image.colorMatrix = function( $sourceImg , $matrix , $hueRadian )
	{
		var $newCanvas = document.createElement( "canvas" ) ;
		$newCanvas.width = $sourceImg.width ;
		$newCanvas.height = $sourceImg.height ;
		var $newContext = $newCanvas.getContext( "2d" ) ;
		$newContext.drawImage( $sourceImg , 0 , 0 ) ;

		var $imgData = $newContext.getImageData( 0 , 0 , $sourceImg.width , $sourceImg.height ) ;
		var $data = $imgData.data ;
		var $length = $data.length ;
		var r , g , b , a ;

		for( var $i = 0 ; $i < $length ; $i += 4 )
		{
			r = $data[ $i+0 ] / 255 ;
			g = $data[ $i+1 ] / 255 ;
			b = $data[ $i+2 ] / 255 ;
			a = $data[ $i+3 ] / 255 ;
			$data[ $i+0 ] = ( r * $matrix[0] + g * $matrix[1] + b * $matrix[2] + a * $matrix[3] ) * 255 ;
			$data[ $i+1 ] = ( r * $matrix[5] + g * $matrix[6] + b * $matrix[7] + a * $matrix[8] ) * 255 ;
			$data[ $i+2 ] = ( r * $matrix[10] + g * $matrix[11] + b * $matrix[12] + a * $matrix[13] ) * 255 ;
			$data[ $i+3 ] = ( r * $matrix[15] + g * $matrix[16] + b * $matrix[17] + a * $matrix[18] ) * 255 ;
		}


		if( $hueRadian )
		{
			// $rotation = ($rotation || 0) / 180 * Math.PI ;
			var cos = Math.cos($hueRadian) ;
			var sin = Math.sin($hueRadian) ;

			// luminanceRed, luminanceGreen, luminanceBlue
			var lumR = 0.213;
			var lumG = 0.715;
			var lumB = 0.072;

			var $matrix = [
			lumR + cos * (1 - lumR) + sin * (-lumR),
			lumG + cos * (-lumG) + sin * (-lumG),
			lumB + cos * (-lumB) + sin * (1 - lumB),
			0, 0,

			lumR + cos * (-lumR) + sin * (0.143),
			lumG + cos * (1 - lumG) + sin * (0.140),
			lumB + cos * (-lumB) + sin * (-0.283),
			0, 0,

			lumR + cos * (-lumR) + sin * (-(1 - lumR)),
			lumG + cos * (-lumG) + sin * (lumG),
			lumB + cos * (1 - lumB) + sin * (lumB),
			0, 0,
			0, 0, 0, 1, 0
			];


			for( var $i = 0 ; $i < $length ; $i += 4 )
			{
				r = $data[ $i+0 ] / 255 ;
				g = $data[ $i+1 ] / 255 ;
				b = $data[ $i+2 ] / 255 ;
				a = $data[ $i+3 ] / 255 ;
				$data[ $i+0 ] = ( r * $matrix[0] + g * $matrix[1] + b * $matrix[2] + a * $matrix[3] ) * 255 ;
				$data[ $i+1 ] = ( r * $matrix[5] + g * $matrix[6] + b * $matrix[7] + a * $matrix[8] ) * 255 ;
				$data[ $i+2 ] = ( r * $matrix[10] + g * $matrix[11] + b * $matrix[12] + a * $matrix[13] ) * 255 ;
				$data[ $i+3 ] = ( r * $matrix[15] + g * $matrix[16] + b * $matrix[17] + a * $matrix[18] ) * 255 ;
			}
		}

		$newContext.putImageData( $imgData , 0 , 0 ) ;

		return $newCanvas ;
	}

	//       -       -       -       -       -       -       -       -

	Utils.Image.colorTransform.reverse = function( $sourceImg )
	{
		var $newCanvas = document.createElement( "canvas" ) ;
		$newCanvas.width = $sourceImg.width ;
		$newCanvas.height = $sourceImg.height ;
		var $newContext = $newCanvas.getContext( "2d" ) ;
		$newContext.drawImage( $sourceImg , 0 , 0 ) ;

		var $imgData = $newContext.getImageData( 0 , 0 , $sourceImg.width , $sourceImg.height ) ;
		var $data = $imgData.data ;
		var $length = $data.length ;
		for( var $i = 0 ; $i < $length ; $i += 4 )
		{
			$data[ $i+0 ] = 255 - $data[ $i+0 ] ;
			$data[ $i+1 ] = 255 - $data[ $i+1 ] ;
			$data[ $i+2 ] = 255 - $data[ $i+2 ] ;
		}

		$newContext.putImageData( $imgData , 0 , 0 ) ;

		return $newCanvas ;
	}

// -   -   -   -   -   -   -   -   -   -   -   -   -   -   -   -   -   -   -   -   -   -   -   -   -   -   -   -   -   -   -   -


	Color = function( $rgbArr )
	{
		var $this = this ;

		$this.r = $rgbArr[0] == undefined ? 0 : $rgbArr[0] ;
		$this.g = $rgbArr[1] == undefined ? 0 : $rgbArr[1] ;
		$this.b = $rgbArr[2] == undefined ? 0 : $rgbArr[2] ;

		//   -   -   -   -   -   -   -   -   -   -   -   -   -   -   -   -   -   -

		$this.getColor = function( )
		{
			return "#" + Color.getFF( $this.r ) +
						 Color.getFF( $this.g ) +
						 Color.getFF( $this.b ) ;
		}

		//   -   -   -   -   -   -   -   -   -   -   -   -   -   -   -   -   -   -

		$this.change = function( $rgbArr , $twObj , $evtObj )
		{
			var $r = $rgbArr[0] ;
			var $g = $rgbArr[1] ;
			var $b = $rgbArr[2] ;

			$twObj = $twObj == undefined ? { time:0.5 , transition:"linear" } : $twObj ;
			$twObj.r = $r ;
			$twObj.g = $g ;
			$twObj.b = $b ;

			Tween.add.update( $this , $twObj , $evtObj ) ;
		}
	}


// - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -


	Color.uint = {} ;
	Color.uint.RGB255 = function( $colorRgb )
	{
		return	[ ($colorRgb >> 16) & 0xFF , ($colorRgb >> 8) & 0xFF , $colorRgb & 0xFF ] ;
	}
	Color.uint.ARGB255 = function( $colorArgb )
	{
		return	[ ($colorArgb >> 24) & 0xFF , ($colorArgb >> 16) & 0xFF , ($colorArgb >> 8) & 0xFF , $colorArgb & 0xFF ] ;
	}

	Color.FF = ["0","1","2","3","4","5","6","7","8","9","A","B","C","D","E","F"] ;
	Color.getFF = function( $num )
	{
		return Color.FF[ Math.max( Math.min( Math.floor( $num/16 ) , 15 ) , 0 ) ] + Color.FF[ Math.max( Math.min( Math.floor($num%16) , 15 ) , 0 ) ] ;
	}
	Color.getUINT = function( $colorStr )
	{
		$colorStr = $colorStr.toUpperCase( ) ;

		var $colorArr = [] ;

		$colorArr[ $colorArr.length ] = Number( Utils.Array.indexOf( Color.FF , $colorStr.charAt( 0 ) ) ) * 16 + Number( Utils.Array.indexOf( Color.FF , $colorStr.charAt( 1 ) ) ) ;
		$colorArr[ $colorArr.length ] = Number( Utils.Array.indexOf( Color.FF , $colorStr.charAt( 2 ) ) ) * 16 + Number( Utils.Array.indexOf( Color.FF , $colorStr.charAt( 3 ) ) ) ;
		$colorArr[ $colorArr.length ] = Number( Utils.Array.indexOf( Color.FF , $colorStr.charAt( 4 ) ) ) * 16 + Number( Utils.Array.indexOf( Color.FF , $colorStr.charAt( 5 ) ) ) ;

		return $colorArr ;
	}
	Color.rgb = {} ;
	Color.rgb.getUINT = function( $r , $g , $b )
	{
		return ($r << 16) + ($g << 8) + $b ;
	}


//-------------------------------------------------------------------------------------------------------------------------------


} )( ) ;
